module.exports = __webpack_public_path__ + "img/logo-l-vk.4db92520.png";